import { ButtonSelectionGroupClass } from '../../../components/button-selection-group-fields/descope-button-selection-group/ButtonSelectionGroupClass';
import { createBaseButtonSelectionGroupMappings } from './baseButtonSelectionGroup';

const vars = ButtonSelectionGroupClass.cssVarList;

const buttonSelectionGroup = {
  ...createBaseButtonSelectionGroupMappings(vars),
};

export default buttonSelectionGroup;
export { vars };
